<template>
  <div class="p-2 mt-2 border rounded workingday">
    <button @click="showDetails = !showDetails">
      {{ showDetails ? "-" : "+" }}
    </button>
    <h4 class="ml-3 d-inline-block">
      {{ formatNumberAsDate(workingDay.date) }}
      {{
        workingDay.stopped || allowEdit
          ? " [" + formatSecondsAsWorkTime(workingDay.numberOfSeconds) + "]"
          : "(NICHT BEENDET!)"
      }}
    </h4>
    <p v-if="workingDay.corrected">
      {{ "Arbeitszeit korrigiert: " + workingDay.corrected }}
    </p>
    <div class="ml-3 d-inline-block" v-if="allowEdit">
      <button
        v-if="!workingDay.stopped && !workingDay.corrected && !doEdit"
        class="btn btn-danger"
        @click="startEdit()"
      >
        Arbeitszeit korrigieren (nicht beendet)
      </button>
      <button
        v-if="(workingDay.stopped || workingDay.corrected) && !doEdit"
        class="btn btn-outline-dark"
        @click="startEdit()"
      >
        Arbeitszeit anpassen...
      </button>
      <div v-if="doEdit">
        <input v-model="timeString" />
        <button class="btn btn-outline-dark" @click="save">Speichern</button>
        <button class="btn btn-outline-dark" @click="doEdit = false">
          Abbrechen
        </button>
      </div>
    </div>
    <div class="ml-3 mt-3" v-if="showDetails">
      <div
        v-for="(trackingItem, index) in workingDay.trackingItems"
        :key="trackingItem.timestamp"
      >
        <p>
          {{ index + 1 }}) {{ getTimeFromSeconds(trackingItem.timestamp) }}
          {{ trackingItem.extRef }} {{ trackingItem.name }}
          {{ trackingItem.stopped ? "STOP" : trackingItem.tasks }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDateFromTimestamp,
  formatSecondsAsWorkTime,
  getTimeFromSeconds,
  formatNumberAsDate
} from "@/common/timetrackingutils";
import { getCookie } from "@/common/utils";

export default {
  name: "workingDayDetails",
  data: function() {
    return {
      showDetails: false,
      doEdit: false,
      timeString: "",
      getTimeFromSeconds: getTimeFromSeconds,
      formatSecondsAsWorkTime: formatSecondsAsWorkTime,
      formatNumberAsDate: formatNumberAsDate
    };
  },
  beforeMount() {
    this.showDetails = getDateFromTimestamp(new Date()) == this.workingDay.date;
  },
  methods: {
    startEdit() {
      this.timeString = formatSecondsAsWorkTime(
        this.workingDay.numberOfSeconds
      );
      this.doEdit = true;
    },
    save() {
      let parts = this.timeString.split(":");
      let h = Number.parseInt(parts[0]);
      let m = Number.parseInt(parts[1]);
      let s = Number.parseInt(parts[2]);
      h = isNaN(h) ? 0 : h;
      m = isNaN(m) ? 0 : m;
      s = isNaN(s) ? 0 : s;

      if (h + m + s === 0) {
        this.workingDay.corrected = null;
        this.workingDay.numberOfSeconds = 0;
        let lastStartValue = 0;
        for (const trackingItem of this.workingDay.trackingItems) {
          if (lastStartValue > 0) {
            if (trackingItem.stopped) {
              this.workingDay.numberOfSeconds +=
                trackingItem.timestamp - lastStartValue;
              lastStartValue = 0;
            }
          } else {
            if (!trackingItem.stopped) {
              lastStartValue = trackingItem.timestamp;
            }
          }
        }
      } else {
        this.workingDay.numberOfSeconds = h * 3600 + m * 60 + s;
        this.workingDay.corrected =
          new Date().toISOString() + " - " + getCookie("lastusername");
      }

      this.doEdit = false;
      this.$emit("save");
    }
  },
  props: ["workingDay", "allowEdit"]
};
</script>
